import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { ToastHelperProvider } from '../../providers/toast-helper/toast-helper';

import { LotDetailPage } from '../lot-detail/lot-detail';
import { StatusDetailPage } from '../status-detail/status-detail';
/**
 * Generated class for the LotenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-loten',
  templateUrl: 'loten.html',
})
export class LotenPage {
  public data;
  public loading;
  public aucId;
  public aucTitle;
  public loose = false;
  public dates = [];
  public dataLoaded: boolean = false;
  public failedRequest: boolean = false;
  constructor(public navCtrl: NavController, 
              public navParams: NavParams,
              public loadingCtrl: LoadingController,
              public rest: RestProvider,
              public alertCtrl: AlertController,
              public toastHelper: ToastHelperProvider) {
  }

  ionViewWillEnter(){
    this.loading = this.loadingCtrl.create({
      content: 'Ophalen van loten...'
    });
    this.loading.present();
    this.aucId = this.navParams.get('aucId');
    this.aucTitle = this.navParams.get('aucTitle');
    this.getDataFromCms();
    if (this.navParams.get('loose')) {
      this.loose = this.navParams.get('loose');
    }
  }

  getDataFromCms(){
    if (!this.rest.checkConnection()) {
      this.presentNoConnectionAlert(this.getDataFromCms.bind(this), function(){this.failedRequest = true;});
      return false;
    }
    this.rest.getLotsForAuction(this.aucId).subscribe((data) => {
      console.log(data);
      if (data) {
        this.loading.dismiss();
        this.data = JSON.parse(String(data));
        if (this.loose) {
          this.dates = Object.keys(this.data); 
        }
        this.failedRequest = false;
        this.dataLoaded = true;
        return true;
      }else{
        this.restError();
        return false;
      }
    }, error => {
      this.restError();
      return false;
    });
  }

  itemClicked(item){
    this.navCtrl.push(LotDetailPage, {
      id: item.id
    });
  }

  doRefresh($event){
    if (!this.rest.checkConnection()) {
      this.toastHelper.showToast('ERROR: kon geen verbinding maken', 'error');
      $event.complete();
    }else{
      var that = this;
      let promise = new Promise(function(resolve, reject) {
        that.rest.getLotsForAuction(that.aucId).subscribe((data) => {
          console.log(data);
          if (data) {
            console.log('resolve');
            resolve(data);
          }else{
            console.log('reject');
            reject();
            // that.restError();
          }
        }, error => {
          console.log('reject2');
          reject();
          // that.restError();
        });
      });
      promise.then((data) => {
        that.data = JSON.parse(String(data));
        if (that.loose) {
          that.dates = Object.keys(that.data); 
        }
        that.failedRequest = false;
        that.dataLoaded = true;
        that.toastHelper.showToast('Loten opgehaald');
        $event.complete();
      }).catch((err) => {
        that.toastHelper.showToast('ERROR: kon de loten niet ophalen.', 'error');
        $event.complete();
      });
    }  
  }

  presentNoConnectionAlert(retryCb, cancelCb = null){
    let alert = this.alertCtrl.create({
      title: 'Geen internet',
      message: 'Kon geen verbinding maken',
      buttons: [
        {
          text: 'Annuleer',
          role: 'cancel',
          handler: () => {
            this.toastHelper.showToast('ERROR: Geen internetverbinding gevonden.', 'error');
            if (cancelCb != null) {
              cancelCb();
            }
            this.loading.dismiss();
          }
        },
        {
          text: 'Probeer opnieuw',
          handler: () => {
            retryCb();
          }
        }
      ]
    });
    alert.present();
  }

  restError(dismiss = true){
    this.toastHelper.showToast('ERROR: Kon de loten niet ophalen.', 'error');
    if(dismiss){this.loading.dismiss()};
    // this.failedRequest = true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/loten/loten.ts